import { SafeHtml } from "@angular/platform-browser";
import { SocketMessageType } from "./websockets";


export class Message {
      messageId: number;
      userId:number;
      dateCreated: Date;
      dateRead: Date | null;
      message:string ;
      messageLong: string;
      value:number;
      messageType: SocketMessageType | null;
      action1Url: string | null;
      action1Text: string | null;
      messageOpened:boolean;
      messageGroupId: string;
      pdfBase64: string | null;
      poll?: PollWithOptions | null;
      pollResponse?: PollResponse | null;
}

export class UnreadMessages {
      userId: number
      messages: Message[] = []
      messageCount: number
}

export class MessageSendConfig{
      franchiseIds: number[];
      clientIds: number[];
      roleIds: number[];
}
export class NewMessage extends Message {
      isPopup: boolean;
      sendConfig: MessageSendConfig;
      createdByUserId: number;
}


export class SendMessageReceipients {
      franchises: {
            id: number;
            name: string;
      }[];
      clients: {
            id: number;
            name: string;
            franchiseId: number;
      }[];
      roles: {
            id: number;
            name: string;
            clientId: number;
      }[];
}

export class InboxMessageGroup{
      id: number;
      messageGroupUuid: string;
      message: string;
      messageLong: string;
      createdBy: number;
      dtCreated: Date;
      pdfBase64: string;
      poll?: PollWithOptions | null;
}

export class MessageRecipient{
      userId: number;
      cell: string;
      franchise: string;
      name: string;
      branch: string;
      messageGroupUuid: string;
      dtRead: Date | null;
}

export class SendMessageResponse extends NewMessage{
      userIds: number[];
}

//Polling Classes
export class Poll{
      pollId: number;
      inboxMessageGroupId: string | null;
      createdBy: number;
      createdDate: Date;
      questionText: string;
      typeId: number;
}

export class PollResponseOption{
    pollResponseOptionId: number
    pollId: number
    optionText: string
    value: number
}

export class PollResponse{
    pollResponseId: number
    pollId: number
    selectedPollResponseOptionId: number | null = null
    userId: number
    answeredDate: Date;
}

export class PollWithOptions extends Poll {
      responseOptions : PollResponseOption[]
}

export class PollWithOptionsAndResponse extends PollWithOptions {
      response: PollResponse | null
}